import { serviceChannelsSchema } from './schema';
import ServiceChannelsEdit from './ServiceChannelsEdit';
import ServiceChannelsView from './ServiceChannelsView';

import iconSVG from '@plone/volto/icons/discussion.svg';

const applyConfig = (config) => {
  config.blocks.blocksConfig.serviceChannelsBlock = {
    id: 'serviceChannelsBlock',
    title: 'Service channels',
    group: 'govbr',
    icon: iconSVG,
    view: ServiceChannelsView,
    edit: ServiceChannelsEdit,
    blockSchema: serviceChannelsSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    // initialValue: initialValue,
  };
  return config;
};

export default applyConfig;
